export default "__VITE_ASSET__D1g5z0vO__"